import moment from 'moment';
import React from 'react';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { Card, CardContent, CardHeader, Typography } from '@mui/material';
import ClassInfoCard from '../../../../components/ClassInfoCard';
import palette from '../../../../theme/palette';
import '../../../../css/overview.css';

const useStyles = makeStyles({
  containerStyle: {
    marginTop: 15
  },
  characterContainer: {
    textAlign: 'end',
    color: palette.grey[500]
  }
});

export default function StudentOverview({ classDetails }) {
  const classes = useStyles();

  return (
    <div className={classes.containerStyle}>
      <ClassInfoCard classDetails={classDetails} isStudent />
      <div style={{ marginTop: 20 }}>
        <Card>
          <CardHeader
            title="Notice Board"
            action={
              <Typography
                sx={{
                  color: '#00000099',
                  fontSize: '14px'
                }}
              >
                Update on {moment(classDetails.updatedAt).format('DD MMM, YYYY')}
              </Typography>
            }
          />
          <CardContent>
            <Typography
              sx={{
                color: '#00000099',
                fontSize: '16px'
              }}
            >
              {classDetails.description || '-'}
            </Typography>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

StudentOverview.propTypes = {
  classDetails: PropTypes.shape({
    description: PropTypes.string,
    updatedAt: PropTypes.string
  })
};
